import { WieMetricDefinition } from './wie-metrics.types';
import { wiePayerConnectionsActiveMetric } from './metrics/wie-payer-connections';
import { wieFlagsMetric } from './metrics/wie-flags';

export const WIE_METRIC_DEFINITIONS: WieMetricDefinition[] = [
  wieFlagsMetric,
  wiePayerConnectionsActiveMetric,
];
